import { call } from 'redux-saga/effects'

export function* toggleMapView() {
  const driverMapDOM = document.getElementById('driver-map-view').classList
  const mainContent = document.getElementsByTagName('body')[0].classList

  yield call([driverMapDOM, driverMapDOM.toggle], 'map-show')
  yield call([driverMapDOM, driverMapDOM.toggle], 'map-hide')
  yield call([mainContent, mainContent.toggle], 'locked-main-content')
}



// WEBPACK FOOTER //
// ./src/sagas/mapViewSaga.js